<div class="view-header" [class.no-banner]="embedService.embed">
  @if (job$ | async; as job) {
    <div class="view-header-content">
      <h1>{{ job.jobTitle }}</h1>
      <div class="content">
        @if (!refService.refCompany && !embedService.embed) {
          <ul>
            <li>{{ job.companyTitle }}</li>
            @if (job?.website) {
              <li>
                <a [href]="job?.website" target="_blank">
                  {{ 'jobboard.static.header.website' | transloco }}
                  <fa-icon [icon]="fontawesomeService.regular.externalLink"></fa-icon>
                </a>
              </li>
            }
          </ul>
        }
        <div class="description">
          <app-header-tags
            [startDate]="job.startDate"
            [employmentType]="job.employmentType"
            [workingTime]="job.workingTime"
            [locations]="job.workLocations"
            [workingModel]="job.workingModel"
            [searchRegionAddress]="job.searchRegionAddress"
            [showSalaryRangeOnJobboard]="job.showSalaryRangeOnJobboard ?? false"
            [salaryCurrency]="job.currency"
            [salaryMin]="job.salaryMin"
            [salaryMax]="job.salaryMax"
            [fallbackSalary]="job.salary"
            [salaryInterval]="job.salaryInterval"
          ></app-header-tags>
          @if (!submitSuccess() && job && job?.open && linkValid() === true) {
            <div class="apply">
              <app-job-apply-actions
                [job]="job"
                [applyLink]="applyLink(job)"
                [applyQueryParams]="applyQueryParams()"
              />
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
@if (linkValid() === true) {
  @if (!submitSuccess()) {
    @if (job$ | async; as job) {
      <div class="view-content">
        <h1>{{ job.jobTitle }}</h1>
        <div class="view-section">
          @if (!job?.open) {
            <ct-lib-inline-info>
              <p>{{ 'jobboard.views.job.closed-info' | transloco }}</p>
            </ct-lib-inline-info>
          }
          @for (description of job.description; track description) {
            <ct-lib-markdown-viewer [value]="description"></ct-lib-markdown-viewer>
          }
          @if (job?.open) {
            <div class="apply">
              <app-job-apply-actions
                [job]="job"
                [applyLink]="applyLink(job)"
                [applyQueryParams]="applyQueryParams()"
              />
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <div class="view-content success">
      <div class="d-flex flex-column align-items-center">
        <app-animated-check [color]="colorService.accent"></app-animated-check>
        <p class="mt-5">{{ 'jobboard.views.apply.sections.finish.done' | transloco }}</p>
        @if (!auth.loggedIn()) {
          <p class="register-cta">{{ 'jobboard.views.apply.sections.finish.register-cta' | transloco }}</p>
          <button type="button" class="ct-btn ct-btn-themed-solid" (click)="openRegister()">
            {{ 'jobboard.views.apply.sections.finish.register-cta-button' | transloco }}
          </button>
        }
      </div>
    </div>
  }
} @else if (linkValid() === false) {
  <div class="view-content">
    <div class="d-flex flex-column align-items-center">
      <app-animated-cross></app-animated-cross>
      <p class="mt-5">{{ 'jobboard.views.job.recommendation-link-invalid' | transloco }}</p>
    </div>
  </div>
}
